import { render, staticRenderFns } from "./ExpandRowWrapper.vue?vue&type=template&id=db1285f4&scoped=true&"
import script from "./ExpandRowWrapper.vue?vue&type=script&lang=ts&"
export * from "./ExpandRowWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1285f4",
  null
  
)

export default component.exports